import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import DetailViewTabTemplate from '../Templates/DetailViewTabTemplate';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography/Typography';

/** @author: Simon  */

interface Properties {
  loading: boolean;
  renderMetaDataForms: () => JSX.Element;
  renderPropsCommandBar: () => JSX.Element;
  retrievedForms?: Object;
  noMetadata?: Object;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: (props: Properties) => 'black'
    },
    button: {
      marginLeft: 30
    },
    commandbar: {
      height: theme.layout.detailview.commandbarHeight,
      marginLeft: theme.layout.detailview.margin,
      marginRight: theme.layout.detailview.margin
    },
    noMetadata: {
      margin: 40
    }
  })
);

/** Draws UI for Meta data panel within detailview */
export default function DetailViewMetaDataUI(props: Properties): JSX.Element {
  const classes = useStyles(props);

  const {
    renderMetaDataForms,
    loading,
    retrievedForms,
    renderPropsCommandBar
  } = props;

  return (
    <DetailViewTabTemplate
      loading={loading}
      renderPropsCommandBar={renderPropsCommandBar}
      renderPropsContents={
        !retrievedForms
          ? () => (
              <div className={classes.noMetadata}>
                <Typography colorVariant="02">No metadata yet</Typography>
              </div>
            )
          : renderMetaDataForms
      }
    />
  );
}
